/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';
import type { LookupType } from './LookupType';
import {
    LookupTypeFromJSON,
    LookupTypeFromJSONTyped,
    LookupTypeToJSON,
} from './LookupType';

/**
 * 
 * @export
 * @interface UploadLookupMappingFileRequestContent
 */
export interface UploadLookupMappingFileRequestContent {
    /**
     * 
     * @type {LookupType}
     * @memberof UploadLookupMappingFileRequestContent
     */
    mappingType: LookupType;
    /**
     * 
     * @type {string}
     * @memberof UploadLookupMappingFileRequestContent
     */
    fileContent: string;
    /**
     * 
     * @type {string}
     * @memberof UploadLookupMappingFileRequestContent
     */
    fileName: string;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof UploadLookupMappingFileRequestContent
     */
    callingIdentity: CallingIdentity;
}


/**
 * Check if a given object implements the UploadLookupMappingFileRequestContent interface.
 */
export function instanceOfUploadLookupMappingFileRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mappingType" in value;
    isInstance = isInstance && "fileContent" in value;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "callingIdentity" in value;

    return isInstance;
}

export function UploadLookupMappingFileRequestContentFromJSON(json: any): UploadLookupMappingFileRequestContent {
    return UploadLookupMappingFileRequestContentFromJSONTyped(json, false);
}

export function UploadLookupMappingFileRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadLookupMappingFileRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mappingType': LookupTypeFromJSON(json['mappingType']),
        'fileContent': json['fileContent'],
        'fileName': json['fileName'],
        'callingIdentity': CallingIdentityFromJSON(json['callingIdentity']),
    };
}

export function UploadLookupMappingFileRequestContentToJSON(value?: UploadLookupMappingFileRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mappingType': LookupTypeToJSON(value.mappingType),
        'fileContent': value.fileContent,
        'fileName': value.fileName,
        'callingIdentity': CallingIdentityToJSON(value.callingIdentity),
    };
}

